var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "selected-song" }, [
      _c("img", { attrs: { src: _vm.assignmentImg } })
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("router-link", { attrs: { to: "/gameplay" } }, [
          _c("img", {
            staticClass: "start-btn",
            attrs: { src: require("@/assets/img/アセット 56@3x.png") },
            on: {
              click: function($event) {
                return _vm.playStart()
              }
            }
          })
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49c98658", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c98658","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Selectedsong.vue
// module id = null
// module chunks = 